module.exports = __webpack_public_path__ + "img/perm.dca3c085.jpg";